import { Routes, Route, useLocation } from "react-router-dom";
import {
  Navbar,
  Footer,
  PrivacyPolicy,
  TermsnConditions,
  Disclaimer,
  ShippingandDelivery,
  ReturnPolicy,
  Error404,
  Home,
  Aboutus,
  Contactus,
  FAQ,
  Gallery,
  Donate,NewsHightlights,
  OurMembers,
} from "./routes/Routes";


import PrivateRoute from "./hooks/PrivateRoute";
import Login from "./routes/auth/login";
import Dashboard from "./routes/auth/dashboard";
import AdminContactus from "./routes/auth/AdminContactus";
import AdminNavbar from "./routes/auth/AdminNavbar";
import GoogelAnalytics from './routes/auth/GoogelAnalytics'
import AdminDonations from "./routes/auth/AdminDonations.jsx";
import AdminMembers from "./routes/auth/AdminMembers.jsx"
import MyAccount from './routes/auth/MyAccount.jsx'

import BecomeAMember from "./routes/Pages/BecomeaMember/BecomeAMember";
import IDCard from "./routes/Pages/BecomeaMember/IDCards";

import WinningMoments from "./routes/Pages/Our Milestones/WinningMoments";
import EducationSystem from "./routes/Pages/Our Milestones/EducationSystem";
import Achievements from "./routes/Pages/Our Milestones/Achievements";
import Gratitude from "./routes/Pages/Our Milestones/Gratitude";
import CrcPublications from "./routes/Pages/Our Milestones/CrcPublications.jsx";
import VoiceOfConsumers from "./routes/Pages/VoiceOfConsumers.jsx";

import FileCase from "./routes/FileCase";

import AdminUpcomingEvents from "./routes/auth/AdminUpcomingEvents.jsx";
import AdminCommittee from "./routes/auth/AdminCommittee.jsx";
import OurCommittee from "./routes/Pages/Committee/OurCommittee.js";
import OldOurCommittee from "./routes/Pages/Committee/OldOurCommittee.js";

const routes = [
  { path: "/", element: <Home /> },
  { path: "/*", element: <Error404 /> },

  { path: "/login", element: <Login /> },
  {
    path: "/auth/dashboard",
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/contactus",
    element: (
      <PrivateRoute>
        <AdminContactus />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/donations",
    element: (
      <PrivateRoute>
        <AdminDonations />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/members",
    element: (
      <PrivateRoute>
        <AdminMembers />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/committee",
    element: (
      <PrivateRoute>
        <AdminCommittee />
      </PrivateRoute>
    ),
  },

  {
    path: "/auth/google-analytics",
    element: (
      <PrivateRoute>
        <GoogelAnalytics />
      </PrivateRoute>
    ),
  },

  {
    path: "/auth/my-account",
    element: (
      <PrivateRoute>
        <MyAccount />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/upcoming-events",
    element: (
      <PrivateRoute>
        <AdminUpcomingEvents />
      </PrivateRoute>
    ),
  },

  { path: "/aboutus", element: <Aboutus /> },
  { path: "/gallery", element: <Gallery /> },
  { path: "/donate", element: <Donate /> },

  { path: "/news-highlights", element: <NewsHightlights /> },


  { path: "/file-case", element: <FileCase /> },

  { path: "/contactus", element: <Contactus /> },

  { path: "/Legal/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/Legal/terms-and-conditions", element: <TermsnConditions /> },
  { path: "/Legal/return-policy", element: <ReturnPolicy /> },
  { path: "/Legal/shipping-and-delivery", element: <ShippingandDelivery /> },
  { path: "/Legal/disclaimer", element: <Disclaimer /> },

  { path: "/frequently-asked-questions", element: <FAQ /> },

    { path: "/our-committee", element: <OurCommittee /> },
    { path: "/old-our-committee", element: <OldOurCommittee /> },
  
  { path: "/our-members", element: <OurMembers /> },

  { path: "/become-a-member", element: <BecomeAMember /> },

  { path: "/id-card", element: <IDCard /> },

  /*--------- Our Milestones ---------*/

  { path: "/winning-moments", element: <WinningMoments /> },
  { path: "/education-system", element: <EducationSystem /> },
  { path: "/voice-of-consumers", element: <VoiceOfConsumers /> },
  { path: "/voice-of-consumer", element: <VoiceOfConsumers /> },
  { path: "/achievements", element: <Achievements /> },
  { path: "/gratitude", element: <Gratitude /> },
  { path: "/crc-publications", element: <CrcPublications /> },
  /*---------PaymentGateways End---------*/
];

export function App() {
  const location = useLocation();

  // Any route that starts with "/auth" (e.g., /auth/dashboard, /auth/contactus)
  const isAuthRoute = location.pathname.startsWith("/auth");
  window.scrollTo(0, 0);

  return (
     <div className="flex flex-col min-h-screen bg-white">
      {/* Show AdminNavbar only on /auth pages */}
      {isAuthRoute && <AdminNavbar />}
      {/* Show Main Navbar on all non-auth pages */}
      {!isAuthRoute && <Navbar />}
      <div className="flex flex-1">
        <div
          className={`flex-1 min-w-0 transition-all duration-300 ${
            isAuthRoute ? "mt-14 md:ml-64" : "mt-0"
          }`}
        >
          <Routes location={location} key={location.pathname}>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>

          {/* Footer only on non-auth pages */}
          {!isAuthRoute && <Footer />}
        </div>{" "}
      </div>{" "}
    </div>
  );
}

export default App;
